import {Accordion} from '@shopify/marketing-assets';

import '../../application';

new Accordion(document.getElementById('Accordion'), {
  mobileOnly: true,
  openFirst: false,
  itemSelector: '.accordion-item--mobile',
  itemLink: '.accordion-link',
  itemContent: '.accordion-content',
});

